import Home from './home/home'

const SUB_SYSTEM = 'company'
export const statisticsApi = new Home(SUB_SYSTEM, 'supplier')
